
import { computed, defineComponent, PropType, Ref } from 'vue';
import { PersonalOfferModuleSofaItemModel, PersonalOfferRegularItemModel, SpecificationAttribute } from '@/b2c/shared/api/server-apis';
import AddOfferItemToBasket from '@/b2c/offers/ui/AddOfferItemToBasket.vue';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import RegularItemImage from '@/b2c/offers/ui/helpers/RegularItemImage.vue';
import RegularItemPrice from '@/b2c/offers/ui/helpers/RegularItemPrice.vue';
import RegularItemQuantity from '@/b2c/offers/ui/helpers/RegularItemQuantity.vue';
import useProductSpecs from '@/shared/product/useProductSpecs';

export default defineComponent({
    name: 'ModuleSofaItem',
    components: { RegularItemQuantity, RegularItemPrice, RegularItemImage, AddOfferItemToBasket },
    props: {
        item: {
            type: Object as PropType<PersonalOfferModuleSofaItemModel>,
            required: true,
        },
    },
    setup(props) {
        const labels = useBlockLabels();
        const { getSpecs, getWidth } = useProductSpecs();
        const isPurchasable: Ref<boolean> = computed(() => {
            const discontinued = props.item.modules.find(item => (item as PersonalOfferRegularItemModel).variant.isDiscontinued);
            return !discontinued;
        });
        const modules: Ref<PersonalOfferRegularItemModel[]> = computed(() => {
            return props.item.modules as PersonalOfferRegularItemModel[];
        });

        const moduleSpecs: Ref<SpecificationAttribute[]> = computed(() => {
            if (props.item.modules && props.item.modules.length > 0) {
                const item: PersonalOfferRegularItemModel = props.item.modules[0] as PersonalOfferRegularItemModel;
                return getSpecs(item.variant.specifications ?? [] as SpecificationAttribute[]);
            } else {
                return [];
            }
        });

        return {
            labels,
            isPurchasable,
            modules,
            getWidth,
            moduleSpecs,
        };
    },
});
